<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/nmb4tp/tc-custom/9781488001765.jpg?1721404212755" alt="This image is the cover for the book Pregnancy Scandal, Love and Lipstick"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Pregnancy Scandal, Love and Lipstick
      </h1>
      <p class="bookDescription body article font2">
        <b>They married for the sake of the baby. Will they stay together for love? </b><br/><br/>Widowed power player Phillip Edgewood's political ambitions demand he have a wifethey don't demand he love her. It's a good thing, too, because his heart belongs to the perfect wife he lost. But finding a woman who will say "I do" to his deal proves difficult. Until he meets Alexandra Meerthe sexy CFO he can't resist. She doesn't believe in happily-ever-after, even after their amazing night together. And now she's pregnant with his child! A marriage of convenience should end the scandal and solve all their problemsas long as they don't fall in love
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kat Cantrell
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6cf1c9b7